/**
 * The editor table cell under a viewport point, or `null` off the table.
 *
 * Read off the `data-ri` / `data-ci` every editing `<td>` carries. Both drags
 * that follow the pointer across cells — the range selection and the fill
 * handle — ask this same question, so it is answered once.
 */
export function cellAtPoint(x: number, y: number): {row: number; col: number} | null {
  const td = document.elementFromPoint(x, y)?.closest<HTMLElement>('[data-ri][data-ci]');
  if (!td) return null;
  const row = Number(td.dataset.ri);
  const col = Number(td.dataset.ci);
  return isNaN(row) || isNaN(col) ? null : {row, col};
}
